import React from "react";
import { Slide } from "react-awesome-reveal";
import { Link } from "react-router-dom";

const PrivacyPolicy: React.FC = () => {
    return (
        <div className="pattern_bg bg-white">
            <section className="page_initial_section overflow-hidden">
                <div className="container-md">
                    <div className="section_heading_area">
                        <Slide direction="down" triggerOnce>
                            <h2 className="section_heading text-center">
                                Privacy Policy
                            </h2>
                        </Slide>

                        <Slide direction="up" delay={100} triggerOnce>
                            <p className="section_desc text-center">
                                Last updated: September 19, 2024
                            </p>
                        </Slide>
                    </div>

                    <fieldset className="terms_service_container first">
                        <div className="content_number_area">1</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">Who are we?</h5>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">1.1</h6>
                                <p className="terms_service_desc">
                                    We are Nuvay Private Ltd trading as “Traqdo”. For privacy queries, you can contact us at info@nuvay.digital.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">2</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">What’s the purpose of this policy?</h5>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">2.1</h6>
                                <p className="terms_service_desc">
                                    It tells you what to expect when we collect personal information from users of our website/app. Please only use them if you are completely happy with this policy.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">2.2</h6>
                                <p className="terms_service_desc">
                                    Generally, the policy covers only information provided to us. If you give personal information to other people, such as payment providers or other websites, please check their privacy policies. Nor does this policy apply to personal information that we collect as a “processor”.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">3</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">Might the policy change? </h5>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">3.1</h6>
                                <p className="terms_service_desc">
                                    Yes. We will give you notice of the new version by posting it on our service and communicating it otherwise if appropriate.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">4</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">What do we collect?</h5>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">4.1</h6>
                                <p className="terms_service_desc">
                                    Information that you upload to our service or otherwise give us such as:
                                </p>
                            </div>

                            <div className="terms_service_list_container mb-3">
                                <ul className="terms_service_list">
                                    <li>
                                        your name and contact details and other personal information that you supply on registration;
                                    </li>
                                    <li>
                                        account information such as your username and password and your contact or other account preferences;
                                    </li>
                                    <li>
                                        details about your transactions on our service;
                                    </li>
                                    <li>
                                        other information that you include in messages sent to other users via our service and/or in communications with us; and
                                    </li>
                                    <li className="mb-0">
                                        contact or other information which you give or allow us to use for newsletters or other marketing.
                                    </li>
                                </ul>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">4.2</h6>
                                <p className="terms_service_desc">
                                    Automated browsing information about your use of our service such as: the internet protocol (IP) address used to connect your device to the internet, connection information such as browser type and version, information about your device including device-type and device identifier, operating system and platform, mobile network data, a unique reference number linked to the data you enter on our system, the site from which you arrived at our service, details of your activity with date/time stamps including pages you visited and your searches/transactions.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">4.3</h6>
                                <p className="terms_service_desc">
                                    We may receive limited information about you from our payment/authentication providers (for verification purposes). This information may include your name and contact details.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">5</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                What’s our reason / legal basis for collecting the information?
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">5.1</h6>
                                <p className="terms_service_desc">
                                    Because it’s necessary to take steps at your request to enter into a contract with you and/or to perform such a contract. This applies to information such as initial enquiries and to account, contact and transaction information.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">5.2</h6>
                                <p className="terms_service_desc">
                                    Because it’s in our “legitimate interests”, e.g., sending you marketing communications about our similar products/services, managing and improving our service including tracking usage patterns and preventing or detecting fraud or abuse. This applies to information such as contact details and automated browsing data.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">5.3</h6>
                                <p className="terms_service_desc">
                                    Because you’ve specifically agreed on our service (e.g., by selecting a consent box). This may apply to contact or other information that you specifically agree to us using for certain kinds of marketing. You can withdraw permission at any time as explained on our service or by emailing us at the above email address.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">5.4</h6>
                                <p className="terms_service_desc">
                                    Because it’s necessary to comply with legal or regulatory obligations.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">6</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                How long do we keep personal information?
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">6.1</h6>
                                <p className="terms_service_desc">
                                    We will generally hold your information for our default standard retention period of six years after the end of our contract/relationship with you, but we may delete it earlier/later as set out below or in our terms and conditions.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">6.2</h6>
                                <p className="terms_service_desc">
                                    We will keep your information that we use for email newsletters or other marketing until you tell us to stop sending you such messages.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">6.3</h6>
                                <p className="terms_service_desc">
                                    We will generally keep automated browsing information for up to 14 months.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">6.4</h6>
                                <p className="terms_service_desc">
                                    Even if our contract/relationship with you is over, your personal information may remain available to other users within the relevant project until terminated by the relevant project owner.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">7</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                To whom do we send or make available your personal information?
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">7.1</h6>
                                <p className="terms_service_desc">
                                    To other people who supply us with services, e.g., website/app hosting and management, app admin, payment, messaging, email distribution, e-commerce, online advertising, analytics, social media etc.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">7.2</h6>
                                <p className="terms_service_desc">
                                    To other users of the relevant project.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">7.3</h6>
                                <p className="terms_service_desc">
                                    To regulators, the police and other law enforcement or official authorities to help deal with fraud and abuse and/or comply with legal requirements and/or to protect us or others.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">7.4</h6>
                                <p className="terms_service_desc">
                                    To insurers and professional advisers in connection with our insurance cover or to deal with legal claims.
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">7.5</h6>
                                <p className="terms_service_desc">
                                    To (actual or potential) potential buyers so far as reasonably necessary in the case of a proposed or completed sale or merger or business combination involving all or the relevant part of our business.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">8</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                Do we send your information outside the UK?
                            </h5>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">8.1</h6>
                                <p className="terms_service_desc">
                                    Your personal information (e.g., name, username, contact details, IP address, browsing information) is transferred to companies outside the UK (generally to the US) that provide us with the services mentioned above (see: To whom do we send or make available your personal information?). Where this happens, we will ensure that there is a legal basis to do so, for example in accordance with “adequacy regulations” applying to particular countries, (e.g., the “UK-US Data Bridge” if applicable) or under contracts with standard contractual clauses sanctioned by the Information Commissioner that are designed to provide adequate safeguards for your personal information.
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">9</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                What rights do you have?
                            </h5>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">9.1</h6>
                                <p className="terms_service_desc">
                                    If the legal requirements are met: To ask us for access to your personal information, to rectify it if there are mistakes, to delete it or restrict its use in certain circumstances or to “data portability” or to withdraw any consent you’ve given (e.g., marketing).
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">9.2</h6>
                                <p className="terms_service_desc">
                                    You may also have the right to object to use of your personal information in certain circumstances.
                                </p>
                            </div>

                            <div className="terms_service_sub_container mb-3">
                                <h6 className="content_sub_number">9.3</h6>
                                <p className="terms_service_desc">
                                    If you have a complaint about how we are dealing with your personal information, please contact us via the email address above. If you are not happy with our response or think we are not handling your personal information in accordance with the law, you have the right to complain to the Information Commissioner’s Office (ICO).
                                </p>
                            </div>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">9.4</h6>
                                <p className="terms_service_desc">
                                    For more information about your rights, visit the ICO’s website:&nbsp;
                                    <Link to={'http://www.ico.org.uk'} target="_blank" className="terms_service_link">
                                        www.ico.org.uk.
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="terms_service_container">
                        <div className="content_number_area">10</div>
                        <div className="terms_service_content">
                            <h5 className="terms_service_main_head">
                                What about cookies?
                            </h5>

                            <div className="terms_service_sub_container">
                                <h6 className="content_sub_number">10.1</h6>
                                <p className="terms_service_desc">
                                    For information about our use of cookies and similar technologies, please see our Cookies Policy at
                                    &nbsp;<Link to={'/cookies-policy'} target="_blank" className="terms_service_link">
                                        www.https://traqdo.com/cookies-policy
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </section>
        </div>
    )
}

export default PrivacyPolicy;